import { ComposableMap, Geographies, Geography, Marker } from "react-simple-maps";

const GEO_URL = "https://cdn.jsdelivr.net/npm/world-atlas@2/countries-110m.json";

export default function ScanMap({ points = [] }) {
  const max = Math.max(1, ...points.map((p) => p.count));

  return (
    <div className="relative">
      <div className="border border-border bg-[#060606]">
        <ComposableMap
          projectionConfig={{ scale: 145 }}
          width={800}
          height={380}
          style={{ width: "100%", height: "auto" }}
          data-testid="scan-map"
        >
          <Geographies geography={GEO_URL}>
            {({ geographies }) =>
              geographies.map((geo) => (
                <Geography
                  key={geo.rsmKey}
                  geography={geo}
                  fill="#0e0e0e"
                  stroke="#1c1c1c"
                  strokeWidth={0.4}
                  style={{
                    default: { outline: "none" },
                    hover: { outline: "none", fill: "#141414" },
                    pressed: { outline: "none" },
                  }}
                />
              ))
            }
          </Geographies>
          {points.map((p, i) => {
            const r = 3 + (p.count / max) * 9;
            return (
              <Marker key={i} coordinates={[p.lon, p.lat]}>
                <circle r={r + 6} fill="#00FF66" opacity={0.12} />
                <circle r={r} fill="#00FF66" opacity={0.85} stroke="#00FF66" strokeWidth={0.5}>
                  <animate attributeName="opacity" values="0.85;0.4;0.85" dur="2.2s" repeatCount="indefinite" />
                </circle>
              </Marker>
            );
          })}
        </ComposableMap>
      </div>
      {points.length === 0 && (
        <div className="absolute inset-0 flex items-center justify-center pointer-events-none">
          <p className="font-mono text-xs text-white/40 bg-background/70 px-3 py-1.5 border border-border">
            No located scans yet
          </p>
        </div>
      )}
    </div>
  );
}
